export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AccessCard = {
  error?: Maybe<Error>;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AccessCardStatus>;
  type?: Maybe<AccessCardType>;
  user?: Maybe<UserProfile>;
  validity?: Maybe<DateTimeRange>;
};

export type AccessCardFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  profile?: InputMaybe<UserProfileFilterInput>;
  query?: InputMaybe<QueryInput>;
  status?: InputMaybe<AccessCardStatus>;
};

export type AccessCardInput = {
  id: Scalars['ID']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AccessCardStatus>;
  type?: InputMaybe<AccessCardType>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  validity?: InputMaybe<DateTimeRangeInput>;
};

export enum AccessCardStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum AccessCardType {
  Rfid = 'RFID'
}

export type AccessCardsResponse = {
  error?: Maybe<Error>;
  items?: Maybe<Array<AccessCard>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AdminAccessCard = {
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<AdminAccessCardProfile>;
  status?: Maybe<AccessCardStatus>;
  type?: Maybe<AccessCardType>;
  validity?: Maybe<DateTimeRange>;
};

export type AdminAccessCardFilterInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  profileId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AccessCardStatus>;
};

export type AdminAccessCardMutationResponse = {
  accessCard?: Maybe<AdminAccessCard>;
  error?: Maybe<Error>;
};

export type AdminAccessCardProfile = {
  company?: Maybe<AdminProfileCompany>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminAccessCardResponse = {
  accessCard?: Maybe<AdminAccessCard>;
  error?: Maybe<Error>;
};

export type AdminAccessCardsResponse = {
  error?: Maybe<Error>;
  items?: Maybe<Array<AdminAccessCard>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum AdminAccountLoginMethod {
  Apple = 'APPLE',
  Email = 'EMAIL',
  Google = 'GOOGLE'
}

export type AdminClientUser = {
  companyId?: Maybe<Scalars['ID']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<UserState>;
};

export type AdminClientUserDetail = {
  companyId?: Maybe<Scalars['ID']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locationIds?: Maybe<Array<Scalars['ID']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<UserState>;
};

export enum AdminClientUserField {
  Email = 'EMAIL',
  ExternalId = 'EXTERNAL_ID'
}

export type AdminClientUserFilterInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<UserState>;
};

export type AdminClientUserMutationResponse = {
  clientUser?: Maybe<AdminClientUser>;
  error?: Maybe<Error>;
  field?: Maybe<AdminClientUserField>;
};

export type AdminClientUserResetPasswordResponse = {
  error?: Maybe<Error>;
};

export type AdminClientUserResponse = {
  clientUser?: Maybe<AdminClientUserDetail>;
  error?: Maybe<Error>;
};

export type AdminClientUsersResponse = {
  error?: Maybe<Error>;
  items?: Maybe<Array<AdminClientUser>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AdminCompaniesResponse = {
  error?: Maybe<Error>;
  items?: Maybe<Array<Company>>;
};

export type AdminCompany = {
  contactUser?: Maybe<AdminUserOption>;
  dic?: Maybe<Scalars['String']['output']>;
  ico?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locations?: Maybe<Array<AdminCompanyLocationOption>>;
  name?: Maybe<Scalars['String']['output']>;
  sapId?: Maybe<Scalars['String']['output']>;
  state?: Maybe<CompanyState>;
};

export enum AdminCompanyField {
  Dic = 'DIC',
  Ico = 'ICO'
}

export type AdminCompanyListResponse = {
  error?: Maybe<Error>;
  items?: Maybe<Array<AdminCompany>>;
};

export type AdminCompanyLocationOption = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminCompanyLocationPairInput = {
  companyId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
};

export type AdminCompanyMutationResponse = {
  company?: Maybe<AdminCompany>;
  error?: Maybe<Error>;
  field?: Maybe<AdminCompanyField>;
};

export type AdminCompanyPairingResponse = {
  error?: Maybe<Error>;
};

export type AdminCreateAccessCardInput = {
  key: Scalars['String']['input'];
  profileId: Scalars['ID']['input'];
  status: AccessCardStatus;
  validity: DateTimeRangeInput;
};

export type AdminCreateClientUserInput = {
  companyId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  state: UserState;
};

export type AdminCreateCompanyInput = {
  contactUserId: Scalars['ID']['input'];
  dic: Scalars['String']['input'];
  ico: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sapId?: InputMaybe<Scalars['String']['input']>;
  state: CompanyState;
};

export type AdminCreateDishTypeInput = {
  allergens?: InputMaybe<Array<AllergenType>>;
  category: DishTypeCategory;
  compositionPrimary: Scalars['String']['input'];
  compositionSecondary: Scalars['String']['input'];
  cost: Scalars['String']['input'];
  descriptionPrimary: Scalars['String']['input'];
  descriptionSecondary: Scalars['String']['input'];
  ean: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nameSecondary: Scalars['String']['input'];
  price: Scalars['String']['input'];
  shelfLife?: InputMaybe<Scalars['Float']['input']>;
  state: DishTypeState;
  weight: Scalars['String']['input'];
};

export type AdminCreateFridgeInput = {
  name: Scalars['String']['input'];
  typeId: Scalars['ID']['input'];
};

export type AdminCreateLocationInput = {
  address: Scalars['String']['input'];
  name: Scalars['String']['input'];
  numberOfDiners?: InputMaybe<Scalars['Int']['input']>;
  state: LocationState;
  timezone: Scalars['String']['input'];
};

export type AdminCreateOperatorInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  state: UserState;
};

export type AdminCreateProfileInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  externalData?: InputMaybe<Array<UserExternalDataEntryInput>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  role: UserRole;
  state: UserState;
};

export type AdminCreateProfileLinkCodeInput = {
  id: Scalars['ID']['input'];
};

export type AdminCreateSalesPointInput = {
  companyId: Scalars['ID']['input'];
  contractedMinimum?: InputMaybe<Scalars['Boolean']['input']>;
  contractedQuantity?: InputMaybe<Scalars['Int']['input']>;
  externalControllingId?: InputMaybe<Scalars['String']['input']>;
  externalStockId?: InputMaybe<Scalars['String']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  saleFrom: Scalars['String']['input'];
  saleTo?: InputMaybe<Scalars['String']['input']>;
};

export type AdminDisconnectProfileAccountInput = {
  id: Scalars['ID']['input'];
};

export type AdminDisconnectProfileAccountResponse = {
  error?: Maybe<Error>;
};

export type AdminDishType = {
  allergens?: Maybe<Array<AllergenType>>;
  category?: Maybe<DishTypeCategory>;
  cost?: Maybe<Scalars['String']['output']>;
  ean?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  state?: Maybe<DishTypeState>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type AdminDishTypeDetail = {
  allergens?: Maybe<Array<AllergenType>>;
  category?: Maybe<DishTypeCategory>;
  compositionPrimary?: Maybe<Scalars['String']['output']>;
  compositionSecondary?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  descriptionPrimary?: Maybe<Scalars['String']['output']>;
  descriptionSecondary?: Maybe<Scalars['String']['output']>;
  ean?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameSecondary?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  shelfLife?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<DishTypeState>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
};

export enum AdminDishTypeField {
  ExternalId = 'EXTERNAL_ID'
}

export type AdminDishTypeMutationResponse = {
  dishType?: Maybe<AdminDishTypeDetail>;
  error?: Maybe<Error>;
  field?: Maybe<AdminDishTypeField>;
};

export type AdminDishTypeResponse = {
  dishType?: Maybe<AdminDishTypeDetail>;
  error?: Maybe<Error>;
};

export type AdminDishTypesFilterInput = {
  category?: InputMaybe<DishTypeCategory>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<DishTypeState>;
};

export type AdminDishTypesResponse = {
  error?: Maybe<Error>;
  items?: Maybe<Array<AdminDishType>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AdminEditFridgeSalesPointPairingInput = {
  pairingId: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type AdminFridgeDetail = {
  doorsState?: Maybe<DoorState>;
  id: Scalars['ID']['output'];
  lockState?: Maybe<LockState>;
  meals?: Maybe<AdminFridgeMealCounts>;
  name?: Maybe<Scalars['String']['output']>;
  salesPoints?: Maybe<Array<AdminFridgeSalesPoint>>;
  state?: Maybe<AdminFridgeState>;
  temperature?: Maybe<Scalars['Float']['output']>;
  temperatureMeasuredAt?: Maybe<Scalars['String']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
};

export type AdminFridgeFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<AdminFridgeState>;
};

export type AdminFridgeListItem = {
  doorsState?: Maybe<DoorState>;
  id: Scalars['ID']['output'];
  lockState?: Maybe<LockState>;
  meals?: Maybe<AdminFridgeMealCounts>;
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<AdminFridgeState>;
  temperature?: Maybe<Scalars['Float']['output']>;
  temperatureMeasuredAt?: Maybe<Scalars['String']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
};

export type AdminFridgeMealCounts = {
  mains?: Maybe<Scalars['Int']['output']>;
  snacks?: Maybe<Scalars['Int']['output']>;
  soups?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AdminFridgeMutationResponse = {
  error?: Maybe<Error>;
  fridge?: Maybe<AdminFridgeListItem>;
};

export type AdminFridgeOptionsResponse = {
  error?: Maybe<Error>;
  items?: Maybe<Array<FridgeBase>>;
};

export type AdminFridgePairing = {
  fridgeId: Scalars['ID']['output'];
  fridgeName?: Maybe<Scalars['String']['output']>;
  pairingId: Scalars['String']['output'];
  validFrom?: Maybe<Scalars['String']['output']>;
  validTo?: Maybe<Scalars['String']['output']>;
};

export type AdminFridgeResponse = {
  error?: Maybe<Error>;
  fridge?: Maybe<AdminFridgeDetail>;
};

export type AdminFridgeSalesPoint = {
  externalControllingId?: Maybe<Scalars['String']['output']>;
  externalSapId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  salesPointId: Scalars['ID']['output'];
  validFrom?: Maybe<Scalars['String']['output']>;
  validTo?: Maybe<Scalars['String']['output']>;
};

export enum AdminFridgeSalesPointPairingConflict {
  PairingAlreadyClosed = 'PAIRING_ALREADY_CLOSED',
  PairingOverlapInsert = 'PAIRING_OVERLAP_INSERT',
  PairingOverlapUpdate = 'PAIRING_OVERLAP_UPDATE',
  PairingStillOngoing = 'PAIRING_STILL_ONGOING',
  SalesPointInactive = 'SALES_POINT_INACTIVE'
}

export type AdminFridgeSalesPointPairingResponse = {
  conflict?: Maybe<AdminFridgeSalesPointPairingConflict>;
  error?: Maybe<Error>;
};

export enum AdminFridgeState {
  InService = 'IN_SERVICE',
  OutOfService = 'OUT_OF_SERVICE',
  Restricted = 'RESTRICTED'
}

export type AdminFridgeTemperatureReading = {
  measuredAt?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type AdminFridgeTemperaturesResponse = {
  error?: Maybe<Error>;
  items?: Maybe<Array<AdminFridgeTemperatureReading>>;
};

export type AdminFridgeType = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminFridgeTypesResponse = {
  error?: Maybe<Error>;
  items?: Maybe<Array<AdminFridgeType>>;
};

export type AdminFridgesListResponse = {
  error?: Maybe<Error>;
  items?: Maybe<Array<AdminFridgeListItem>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AdminLocation = {
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminLocationCompanyOption = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminLocationListItem = {
  address?: Maybe<Scalars['String']['output']>;
  companies?: Maybe<Array<AdminLocationCompanyOption>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  numberOfDiners?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<LocationState>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type AdminLocationListResponse = {
  error?: Maybe<Error>;
  items?: Maybe<Array<AdminLocationListItem>>;
};

export type AdminLocationMutationResponse = {
  error?: Maybe<Error>;
  location?: Maybe<AdminLocationListItem>;
};

export type AdminLocationsResponse = {
  error?: Maybe<Error>;
  items?: Maybe<Array<AdminLocation>>;
};

export type AdminLoginCodeRequestResponse = {
  error?: Maybe<Error>;
};

export type AdminLoginWithCodeInput = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type AdminMcpConsentApprovalInput = {
  approvedScopes: Array<Scalars['String']['input']>;
  request: AdminMcpConsentRequestInput;
};

export type AdminMcpConsentDecisionResponse = {
  error?: Maybe<Error>;
  redirectTo?: Maybe<Scalars['String']['output']>;
};

export type AdminMcpConsentRequest = {
  clientId?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  grantExpiresAt?: Maybe<Scalars['String']['output']>;
  requestedScopes?: Maybe<Array<Scalars['String']['output']>>;
};

export type AdminMcpConsentRequestInput = {
  clientId: Scalars['String']['input'];
  codeChallenge: Scalars['String']['input'];
  codeChallengeMethod: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  resource: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type AdminMcpConsentRequestResponse = {
  consentRequest?: Maybe<AdminMcpConsentRequest>;
  error?: Maybe<Error>;
  redirectTo?: Maybe<Scalars['String']['output']>;
};

export type AdminMcpGrant = {
  clientId?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  scopes?: Maybe<Array<Scalars['String']['output']>>;
};

export type AdminMcpGrantsResponse = {
  error?: Maybe<Error>;
  items?: Maybe<Array<AdminMcpGrant>>;
};

export type AdminOperator = {
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<UserState>;
};

export enum AdminOperatorField {
  Email = 'EMAIL'
}

export type AdminOperatorFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<UserState>;
};

export type AdminOperatorMutationResponse = {
  error?: Maybe<Error>;
  field?: Maybe<AdminOperatorField>;
  operator?: Maybe<AdminOperator>;
};

export type AdminOperatorResponse = {
  error?: Maybe<Error>;
  operator?: Maybe<AdminOperator>;
};

export type AdminOperatorsResponse = {
  error?: Maybe<Error>;
  items?: Maybe<Array<AdminOperator>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AdminPaginationInput = {
  items?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminPairFridgeWithSalesPointInput = {
  fridgeId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['String']['input']>;
  salesPointId: Scalars['ID']['input'];
};

export type AdminProfile = {
  account?: Maybe<AdminProfileAccount>;
  company?: Maybe<AdminProfileCompany>;
  email?: Maybe<Scalars['String']['output']>;
  externalData?: Maybe<Array<UserExternalDataEntry>>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UserRole>;
  state?: Maybe<UserState>;
};

export type AdminProfileAccount = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminProfileCompany = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminProfileDetail = {
  account?: Maybe<AdminProfileDetailAccount>;
  company?: Maybe<AdminProfileCompany>;
  email?: Maybe<Scalars['String']['output']>;
  externalData?: Maybe<Array<UserExternalDataEntry>>;
  externalId?: Maybe<Scalars['String']['output']>;
  feedbacks?: Maybe<Array<AdminProfileFeedback>>;
  id: Scalars['ID']['output'];
  locations?: Maybe<Array<AdminProfileLocationOption>>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  purchaseCount?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<UserRole>;
  state?: Maybe<UserState>;
};

export type AdminProfileDetailAccount = {
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  login?: Maybe<AdminAccountLoginMethod>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminProfileDetailResponse = {
  error?: Maybe<Error>;
  profile?: Maybe<AdminProfileDetail>;
};

export type AdminProfileFeedback = {
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  rating?: Maybe<OrderFeedbackRatingType>;
  reason?: Maybe<OrderFeedbackReasonType>;
  transactionId?: Maybe<Scalars['ID']['output']>;
};

export type AdminProfileFilterInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  roles?: InputMaybe<Array<UserRole>>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<UserState>;
};

export type AdminProfileLinkCodeResponse = {
  error?: Maybe<Error>;
};

export type AdminProfileLocationOption = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminProfileMutationResponse = {
  error?: Maybe<Error>;
  profile?: Maybe<AdminProfile>;
};

export type AdminProfilesResponse = {
  error?: Maybe<Error>;
  items?: Maybe<Array<AdminProfile>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AdminRefundTransactionDishInput = {
  dishId: Scalars['ID']['input'];
  transactionId: Scalars['ID']['input'];
};

export type AdminRequestLoginCodeInput = {
  email: Scalars['String']['input'];
};

export type AdminRevokeMcpGrantInput = {
  id: Scalars['ID']['input'];
};

export type AdminRevokeMcpGrantResponse = {
  error?: Maybe<Error>;
};

export type AdminSalesPoint = {
  activeFridge?: Maybe<AdminSalesPointActiveFridge>;
  contractedMinimum?: Maybe<Scalars['Boolean']['output']>;
  contractedQuantity?: Maybe<Scalars['Int']['output']>;
  externalControllingId?: Maybe<Scalars['String']['output']>;
  externalStockId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalName?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  saleFrom?: Maybe<Scalars['String']['output']>;
  saleTo?: Maybe<Scalars['String']['output']>;
  state?: Maybe<AdminSalesPointState>;
};

export type AdminSalesPointActiveFridge = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminSalesPointDetail = {
  activeFridge?: Maybe<AdminSalesPointActiveFridge>;
  companyId?: Maybe<Scalars['ID']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  contractedMinimum?: Maybe<Scalars['Boolean']['output']>;
  contractedQuantity?: Maybe<Scalars['Int']['output']>;
  externalControllingId?: Maybe<Scalars['String']['output']>;
  externalStockId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalName?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pairings?: Maybe<Array<AdminFridgePairing>>;
  saleFrom?: Maybe<Scalars['String']['output']>;
  saleTo?: Maybe<Scalars['String']['output']>;
  state?: Maybe<AdminSalesPointState>;
};

export enum AdminSalesPointField {
  ExternalControllingId = 'EXTERNAL_CONTROLLING_ID'
}

export type AdminSalesPointMutationResponse = {
  error?: Maybe<Error>;
  field?: Maybe<AdminSalesPointField>;
  salesPoint?: Maybe<AdminSalesPoint>;
};

export type AdminSalesPointOption = {
  companyId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminSalesPointOptionsResponse = {
  error?: Maybe<Error>;
  items?: Maybe<Array<AdminSalesPointOption>>;
};

export type AdminSalesPointResponse = {
  error?: Maybe<Error>;
  salesPoint?: Maybe<AdminSalesPointDetail>;
};

export enum AdminSalesPointState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type AdminSalesPointsFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<AdminSalesPointState>;
};

export type AdminSalesPointsResponse = {
  error?: Maybe<Error>;
  items?: Maybe<Array<AdminSalesPoint>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AdminTransactionDetail = {
  movements: Array<AdminTransactionMovement>;
  payment: AdminTransactionPaymentDetail;
  salesPoint?: Maybe<AdminTransactionSalesPointDetail>;
  transaction: TransactionSummary;
};

export type AdminTransactionDishRefund = {
  error?: Maybe<Error>;
};

export type AdminTransactionFilterInput = {
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fridgeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod?: InputMaybe<PaymentMethodType>;
  paymentState?: InputMaybe<PaymentState>;
  profileId?: InputMaybe<Scalars['ID']['input']>;
  range?: InputMaybe<DateTimeRangeInput>;
  salesPointIds?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type AdminTransactionMovement = {
  dishId?: Maybe<Scalars['ID']['output']>;
  dishTypeTitle?: Maybe<Scalars['String']['output']>;
  operation: Scalars['String']['output'];
  price?: Maybe<Scalars['String']['output']>;
  rfidTag?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<DishSegmentType>;
};

export type AdminTransactionPaymentDetail = {
  adyenPspReference?: Maybe<Scalars['String']['output']>;
};

export type AdminTransactionPaymentOptions = {
  error?: Maybe<Error>;
  methods: Array<PaymentMethodType>;
  states: Array<PaymentState>;
};

export type AdminTransactionRecordingResponse = {
  error?: Maybe<Error>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AdminTransactionResponse = {
  error?: Maybe<Error>;
  item?: Maybe<AdminTransactionDetail>;
};

export type AdminTransactionSalesPointDetail = {
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminUnpairFridgeFromSalesPointInput = {
  pairingId: Scalars['String']['input'];
  to?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateAccessCardInput = {
  id: Scalars['ID']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<AccessCardStatus>;
  validity?: InputMaybe<DateTimeRangeInput>;
};

export type AdminUpdateClientUserInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<UserState>;
};

export type AdminUpdateCompanyInput = {
  contactUserId?: InputMaybe<Scalars['ID']['input']>;
  dic?: InputMaybe<Scalars['String']['input']>;
  ico?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  sapId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<CompanyState>;
};

export type AdminUpdateDishTypeInput = {
  allergens?: InputMaybe<Array<AllergenType>>;
  category?: InputMaybe<DishTypeCategory>;
  compositionPrimary?: InputMaybe<Scalars['String']['input']>;
  compositionSecondary?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['String']['input']>;
  descriptionPrimary?: InputMaybe<Scalars['String']['input']>;
  descriptionSecondary?: InputMaybe<Scalars['String']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameSecondary?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  shelfLife?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<DishTypeState>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateFridgeInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<AdminFridgeState>;
};

export type AdminUpdateLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfDiners?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<LocationState>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateOperatorInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<UserState>;
};

export type AdminUpdateProfileInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalData?: InputMaybe<Array<UserExternalDataEntryInput>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  state?: InputMaybe<UserState>;
};

export type AdminUpdateSalesPointInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  contractedMinimum?: InputMaybe<Scalars['Boolean']['input']>;
  contractedQuantity?: InputMaybe<Scalars['Int']['input']>;
  externalControllingId?: InputMaybe<Scalars['String']['input']>;
  externalStockId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  internalName?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  saleFrom?: InputMaybe<Scalars['String']['input']>;
  saleTo?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<AdminSalesPointState>;
};

export type AdminUserAccount = {
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  login?: Maybe<AdminAccountLoginMethod>;
  name?: Maybe<Scalars['String']['output']>;
  profiles?: Maybe<Array<AdminUserAccountProfileRef>>;
  state?: Maybe<UserState>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type AdminUserAccountDetail = {
  email?: Maybe<Scalars['String']['output']>;
  feedbacks?: Maybe<Array<AdminProfileFeedback>>;
  id: Scalars['ID']['output'];
  login?: Maybe<AdminAccountLoginMethod>;
  name?: Maybe<Scalars['String']['output']>;
  paymentMethods?: Maybe<Array<AdminUserAccountPaymentMethod>>;
  profiles?: Maybe<Array<AdminUserAccountProfile>>;
  role?: Maybe<Scalars['String']['output']>;
  state?: Maybe<UserState>;
};

export type AdminUserAccountDetailResponse = {
  account?: Maybe<AdminUserAccountDetail>;
  error?: Maybe<Error>;
};

export type AdminUserAccountFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<UserState>;
};

export type AdminUserAccountPaymentMethod = {
  id: Scalars['ID']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<PaymentMethodState>;
  type?: Maybe<PaymentMethodType>;
};

export type AdminUserAccountProfile = {
  companyName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminUserAccountProfileRef = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminUserAccountsResponse = {
  error?: Maybe<Error>;
  items?: Maybe<Array<AdminUserAccount>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AdminUserOption = {
  company?: Maybe<AdminProfileCompany>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type AdminUsersResponse = {
  error?: Maybe<Error>;
  items?: Maybe<Array<AdminUserOption>>;
};

export type AdyenPaymentRedirect = {
  data?: Maybe<AdyenPaymentRedirectData>;
  method: AdyenPaymentRedirectMethod;
  url: Scalars['String']['output'];
};

export type AdyenPaymentRedirectData = {
  MD: Scalars['String']['output'];
  PaReq: Scalars['String']['output'];
};

export enum AdyenPaymentRedirectMethod {
  Get = 'GET',
  Post = 'POST'
}

export type AggregatedData = {
  dishes?: Maybe<Dishes>;
  id: Scalars['String']['output'];
  revenue?: Maybe<ComparisonData>;
  transactions?: Maybe<ComparisonData>;
};

export type AllOrders = {
  edges?: Maybe<Array<OrderWithFridge>>;
  pageInfo?: Maybe<AllOrdersPageInfo>;
};

export type AllOrdersPageInfo = {
  endCursor?: Maybe<Scalars['ID']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
};

export enum AllergenType {
  Celery = 'CELERY',
  Crustaceans = 'CRUSTACEANS',
  Eggs = 'EGGS',
  Fish = 'FISH',
  Gluten = 'GLUTEN',
  Lupin = 'LUPIN',
  Milk = 'MILK',
  Molluscs = 'MOLLUSCS',
  Mustard = 'MUSTARD',
  Nuts = 'NUTS',
  Peanuts = 'PEANUTS',
  SesameSeeds = 'SESAME_SEEDS',
  Soybeans = 'SOYBEANS',
  Spicy = 'SPICY',
  SulphurDioxide = 'SULPHUR_DIOXIDE'
}

export type ApplePayOrderUpdate = {
  orderId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export enum ApplePayPaymentResult {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED'
}

export type ApplePayResult = {
  error?: Maybe<Error>;
  method?: Maybe<PaymentMethod>;
};

export type ApplePayUpdate = {
  name: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type AppleUser = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<AppleUserName>;
};

export type AppleUserName = {
  first?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['String']['input']>;
};

export type AppliedDiscountCode = {
  amount?: Maybe<AppliedDiscountCodeAmount>;
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AppliedDiscountCodeAmount = {
  applied?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['String']['output']>;
};

export type AppliedDiscountCodeAmountSubscription = {
  applied?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['String']['output']>;
};

export type AppliedDiscountCodeAmountSubscriptionUpdate = {
  applied?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['String']['input']>;
};

export type AppliedDiscountCodeSubscription = {
  amount?: Maybe<AppliedDiscountCodeAmountSubscription>;
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AppliedDiscountCodeSubscriptionUpdate = {
  amount?: InputMaybe<AppliedDiscountCodeAmountSubscriptionUpdate>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Bestsellers = {
  items?: Maybe<Array<OrderSummaryDishItem>>;
};

export type Company = {
  error?: Maybe<Error>;
  id: Scalars['ID']['output'];
  locations?: Maybe<Array<CompanyLocation>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CompanyLocation = {
  address?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum CompanyState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type ComparisonData = {
  difference?: Maybe<DifferenceData>;
  previousPeriod?: Maybe<Scalars['String']['output']>;
  selectedPeriod?: Maybe<Scalars['String']['output']>;
};

export enum CurrencyType {
  Czk = 'CZK',
  Eur = 'EUR'
}

export enum DataGroup {
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH'
}

export enum DateRange {
  LastMonth = 'LAST_MONTH',
  LastQuarter = 'LAST_QUARTER',
  LastWeek = 'LAST_WEEK',
  ThisMonth = 'THIS_MONTH',
  ThisQuarter = 'THIS_QUARTER',
  ThisWeek = 'THIS_WEEK'
}

export type DateTimeRange = {
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type DateTimeRangeInput = {
  from: Scalars['String']['input'];
  to?: InputMaybe<Scalars['String']['input']>;
};

export type DeletePaymentMethodResult = {
  error?: Maybe<Error>;
};

export type DeviceTokenInput = {
  token: Scalars['String']['input'];
};

export type DeviceTokenResponse = {
  error?: Maybe<Error>;
};

export type DifferenceData = {
  absolute?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['String']['output']>;
};

export type Dish = {
  expiration?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  position?: Maybe<DishSegmentType>;
  price?: Maybe<Price>;
  rfid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DishType>;
};

export type DishSegment = {
  capacity?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<DishSegmentType>;
};

export type DishSegmentSubscription = {
  capacity?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<DishSegmentType>;
};

export type DishSegmentSubscriptionUpdate = {
  capacity?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<DishSegmentType>;
};

export enum DishSegmentType {
  Box_1_1 = 'BOX_1_1',
  Box_1_2 = 'BOX_1_2',
  Box_1_3 = 'BOX_1_3',
  Box_1_4 = 'BOX_1_4',
  Box_1_5 = 'BOX_1_5',
  Box_2_1 = 'BOX_2_1',
  Box_2_2 = 'BOX_2_2',
  Box_2_3 = 'BOX_2_3',
  Box_2_4 = 'BOX_2_4',
  Box_2_5 = 'BOX_2_5',
  Box_3_1 = 'BOX_3_1',
  Box_3_2 = 'BOX_3_2',
  Box_3_3 = 'BOX_3_3',
  Box_3_4 = 'BOX_3_4',
  Box_3_5 = 'BOX_3_5',
  Box_4_1 = 'BOX_4_1',
  Box_4_2 = 'BOX_4_2',
  Box_4_3 = 'BOX_4_3',
  Box_4_4 = 'BOX_4_4',
  Box_4_5 = 'BOX_4_5',
  Box_5_1 = 'BOX_5_1',
  Box_5_2 = 'BOX_5_2',
  Box_5_3 = 'BOX_5_3',
  Box_5_4 = 'BOX_5_4',
  Box_5_5 = 'BOX_5_5',
  Box_6_1 = 'BOX_6_1',
  Box_6_2 = 'BOX_6_2',
  Box_6_3 = 'BOX_6_3',
  Box_6_4 = 'BOX_6_4',
  Box_6_5 = 'BOX_6_5'
}

export type DishSegmentUpdate = {
  capacity?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<DishSegmentType>;
};

export type DishSubscription = {
  expiration?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  position?: Maybe<DishSegmentType>;
  price?: Maybe<PriceSubscription>;
  type?: Maybe<DishTypeSubscription>;
};

export type DishSubscriptionUpdate = {
  expiration?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  position?: InputMaybe<DishSegmentType>;
  price?: InputMaybe<PriceSubscriptionUpdate>;
  type?: InputMaybe<DishTypeSubscriptionUpdate>;
};

export type DishType = {
  allergens?: Maybe<Array<AllergenType>>;
  category?: Maybe<DishTypeCategory>;
  description?: Maybe<DishTypeDescription>;
  dishes?: Maybe<Array<Dish>>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  lighting?: Maybe<DishTypeLighting>;
  price?: Maybe<Price>;
  weight?: Maybe<Scalars['String']['output']>;
};

export enum DishTypeCategory {
  Meal = 'MEAL',
  Snack = 'SNACK',
  Soup = 'SOUP'
}

export type DishTypeDescription = {
  primary?: Maybe<DishTypeDescriptionDetail>;
  secondary?: Maybe<DishTypeDescriptionDetail>;
};

export type DishTypeDescriptionDetail = {
  composition?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DishTypeDescriptionDetailSubscription = {
  composition?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DishTypeDescriptionDetailSubscriptionUpdate = {
  composition?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DishTypeDescriptionSubscription = {
  primary?: Maybe<DishTypeDescriptionDetailSubscription>;
  secondary?: Maybe<DishTypeDescriptionDetailSubscription>;
};

export type DishTypeDescriptionSubscriptionUpdate = {
  primary?: InputMaybe<DishTypeDescriptionDetailSubscriptionUpdate>;
  secondary?: InputMaybe<DishTypeDescriptionDetailSubscriptionUpdate>;
};

export type DishTypeLighting = {
  mode?: Maybe<LightingSegmentModeType>;
};

export type DishTypeLightingSubscription = {
  mode?: Maybe<LightingSegmentModeType>;
};

export type DishTypeLightingSubscriptionUpdate = {
  mode?: InputMaybe<LightingSegmentModeType>;
};

export type DishTypeLightingUpdate = {
  mode?: InputMaybe<LightingSegmentModeType>;
};

export type DishTypeRatingResult = {
  error?: Maybe<Error>;
};

export type DishTypeRatingUpdate = {
  comment?: InputMaybe<Scalars['String']['input']>;
  dishTypeId: Scalars['ID']['input'];
  rating: Rating;
};

export enum DishTypeState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type DishTypeSubscription = {
  allergens?: Maybe<Array<AllergenType>>;
  description?: Maybe<DishTypeDescriptionSubscription>;
  dishes?: Maybe<Array<DishSubscription>>;
  id: Scalars['ID']['output'];
  image?: Maybe<ImageSubscription>;
  lighting?: Maybe<DishTypeLightingSubscription>;
  price?: Maybe<PriceSubscription>;
  weight?: Maybe<Scalars['String']['output']>;
};

export type DishTypeSubscriptionUpdate = {
  allergens?: InputMaybe<Array<AllergenType>>;
  description?: InputMaybe<DishTypeDescriptionSubscriptionUpdate>;
  dishes?: InputMaybe<Array<DishSubscriptionUpdate>>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<ImageSubscriptionUpdate>;
  lighting?: InputMaybe<DishTypeLightingSubscriptionUpdate>;
  price?: InputMaybe<PriceSubscriptionUpdate>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

export type DishTypeUpdate = {
  id: Scalars['ID']['input'];
  lighting?: InputMaybe<DishTypeLightingUpdate>;
};

export type Dishes = {
  removed?: Maybe<ComparisonData>;
};

export enum DoorState {
  Closed = 'CLOSED',
  Opened = 'OPENED'
}

export type Error = {
  message?: Maybe<Scalars['String']['output']>;
  type: ErrorType;
};

export type ErrorSubscription = {
  message?: Maybe<Scalars['String']['output']>;
  type: ErrorType;
};

export type ErrorSubscriptionUpdate = {
  message?: InputMaybe<Scalars['String']['input']>;
  type: ErrorType;
};

export enum ErrorType {
  BadRequest = 'BAD_REQUEST',
  CodeExpired = 'CODE_EXPIRED',
  Conflict = 'CONFLICT',
  Forbidden = 'FORBIDDEN',
  InternalError = 'INTERNAL_ERROR',
  NotFound = 'NOT_FOUND',
  NotImplemented = 'NOT_IMPLEMENTED',
  PaymentRejected = 'PAYMENT_REJECTED',
  Timeout = 'TIMEOUT',
  Unauthorized = 'UNAUTHORIZED'
}

export enum FeedbackReasonType {
  EmployeeAccountIssue = 'EMPLOYEE_ACCOUNT_ISSUE',
  MenuIssue = 'MENU_ISSUE',
  Other = 'OTHER',
  PaymentIssue = 'PAYMENT_ISSUE'
}

export type FeedbackResult = {
  error?: Maybe<Error>;
};

export type FeedbackUpdate = {
  comment?: InputMaybe<Scalars['String']['input']>;
  reason: FeedbackReasonType;
};

export type Fridge = FridgeCommon & {
  access?: Maybe<FridgeAccess>;
  dishes?: Maybe<FridgeDishes>;
  door?: Maybe<FridgeDoor>;
  error?: Maybe<Error>;
  id: Scalars['ID']['output'];
  lighting?: Maybe<Lighting>;
  location?: Maybe<FridgeLocation>;
  menu?: Maybe<FridgeMenu>;
  name?: Maybe<Scalars['String']['output']>;
  segments?: Maybe<Array<FridgeSegment>>;
  state?: Maybe<FridgeState>;
  transaction?: Maybe<FridgeTransaction>;
};


export type FridgeMenuArgs = {
  week?: InputMaybe<Scalars['String']['input']>;
};

export type FridgeAccess = {
  qrCode?: Maybe<QrCode>;
};

export type FridgeAccessSubscription = {
  qrCode?: Maybe<QrCodeSubscription>;
};

export type FridgeAccessSubscriptionUpdate = {
  qrCode?: InputMaybe<QrCodeSubscriptionUpdate>;
};

export type FridgeBase = FridgeCommon & {
  externalStockId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<FridgeLocation>;
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<FridgeState>;
};

export type FridgeCommon = {
  id: Scalars['ID']['output'];
  location?: Maybe<FridgeLocation>;
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<FridgeState>;
};

export type FridgeDishes = {
  items?: Maybe<Array<Dish>>;
  type?: Maybe<DishType>;
  types?: Maybe<Array<DishType>>;
};


export type FridgeDishesTypeArgs = {
  id: Scalars['ID']['input'];
};

export type FridgeDishesSubscription = {
  types?: Maybe<Array<DishTypeSubscription>>;
};

export type FridgeDishesSubscriptionUpdate = {
  types?: InputMaybe<Array<DishTypeSubscriptionUpdate>>;
};

export type FridgeDishesUpdate = {
  types?: InputMaybe<Array<DishTypeUpdate>>;
};

export type FridgeDoor = {
  lock?: Maybe<FridgeDoorLock>;
  state?: Maybe<DoorState>;
};

export type FridgeDoorLock = {
  error?: Maybe<Error>;
  state?: Maybe<LockState>;
  timeout?: Maybe<Scalars['Int']['output']>;
};

export type FridgeDoorLockSubscription = {
  error?: Maybe<ErrorSubscription>;
  state?: Maybe<LockState>;
  timeout?: Maybe<Scalars['Int']['output']>;
};

export type FridgeDoorLockSubscriptionUpdate = {
  error?: InputMaybe<ErrorSubscriptionUpdate>;
  state?: InputMaybe<LockState>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
};

export type FridgeDoorSubscription = {
  lock?: Maybe<FridgeDoorLockSubscription>;
  state?: Maybe<DoorState>;
};

export type FridgeDoorSubscriptionUpdate = {
  lock?: InputMaybe<FridgeDoorLockSubscriptionUpdate>;
  state?: InputMaybe<DoorState>;
};

export type FridgeLocation = {
  address?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FridgeMenu = {
  count?: Maybe<Scalars['Int']['output']>;
  dishes?: Maybe<Array<FridgeMenuDish>>;
};

export type FridgeMenuDish = {
  count?: Maybe<Scalars['Int']['output']>;
  dish?: Maybe<DishType>;
};

export type FridgeSegment = {
  light?: Maybe<SegmentLight>;
  segment?: Maybe<DishSegment>;
};

export type FridgeSegmentSubscription = {
  light?: Maybe<SegmentLightSubscription>;
  segment?: Maybe<DishSegmentSubscription>;
};

export type FridgeSegmentSubscriptionUpdate = {
  light?: InputMaybe<SegmentLightSubscriptionUpdate>;
  segment?: InputMaybe<DishSegmentSubscriptionUpdate>;
};

export type FridgeSegmentUpdate = {
  light?: InputMaybe<SegmentLightUpdate>;
  segment?: InputMaybe<DishSegmentUpdate>;
};

export enum FridgeState {
  Empty = 'EMPTY',
  InService = 'IN_SERVICE',
  OutOfService = 'OUT_OF_SERVICE',
  Restricted = 'RESTRICTED'
}

export type FridgeSubscription = {
  access?: Maybe<FridgeAccessSubscription>;
  dishes?: Maybe<FridgeDishesSubscription>;
  door?: Maybe<FridgeDoorSubscription>;
  error?: Maybe<ErrorSubscription>;
  id: Scalars['ID']['output'];
  lighting?: Maybe<LightingSubscription>;
  name?: Maybe<Scalars['String']['output']>;
  segments?: Maybe<Array<FridgeSegmentSubscription>>;
  state?: Maybe<FridgeState>;
  transaction?: Maybe<FridgeTransactionSubscription>;
};

export type FridgeSubscriptionUpdate = {
  access?: InputMaybe<FridgeAccessSubscriptionUpdate>;
  dishes?: InputMaybe<FridgeDishesSubscriptionUpdate>;
  door?: InputMaybe<FridgeDoorSubscriptionUpdate>;
  error?: InputMaybe<ErrorSubscriptionUpdate>;
  id: Scalars['ID']['input'];
  lighting?: InputMaybe<LightingSubscriptionUpdate>;
  name?: InputMaybe<Scalars['String']['input']>;
  segments?: InputMaybe<Array<FridgeSegmentSubscriptionUpdate>>;
  state?: InputMaybe<FridgeState>;
  transaction?: InputMaybe<FridgeTransactionSubscriptionUpdate>;
};

export type FridgeTransaction = {
  order?: Maybe<Order>;
  orders?: Maybe<Orders>;
  refills?: Maybe<Refills>;
};


export type FridgeTransactionOrderArgs = {
  id: Scalars['ID']['input'];
};

export type FridgeTransactionSubscription = {
  orders?: Maybe<OrdersSubscription>;
  refills?: Maybe<RefillsSubscription>;
};

export type FridgeTransactionSubscriptionUpdate = {
  orders?: InputMaybe<OrdersSubscriptionUpdate>;
  refills?: InputMaybe<RefillsSubscriptionUpdate>;
};

export type FridgeTransactionUpdate = {
  orders?: InputMaybe<OrdersUpdate>;
};

export type FridgeUnlock = {
  id: Scalars['ID']['input'];
  profileId?: InputMaybe<Scalars['ID']['input']>;
};

export type FridgeUnlockResponse = {
  error?: Maybe<Error>;
};

export type FridgeUpdate = {
  dishes?: InputMaybe<FridgeDishesUpdate>;
  id: Scalars['ID']['input'];
  lighting?: InputMaybe<LightingUpdate>;
  segments?: InputMaybe<Array<FridgeSegmentUpdate>>;
  transaction?: InputMaybe<FridgeTransactionUpdate>;
};

export type FridgesResponse = {
  error?: Maybe<Error>;
  items?: Maybe<Array<Fridge>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GooglePayMetaUpdate = {
  browser?: InputMaybe<PaymentBrowserUpdate>;
};

export type GooglePayOrderUpdate = {
  meta?: InputMaybe<GooglePayMetaUpdate>;
  orderId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export enum GooglePayPaymentResult {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED'
}

export type GooglePayResult = {
  error?: Maybe<Error>;
  method?: Maybe<PaymentMethod>;
  redirect?: Maybe<AdyenPaymentRedirect>;
};

export type GooglePayUpdate = {
  meta?: InputMaybe<GooglePayMetaUpdate>;
  name: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type Image = {
  url?: Maybe<Scalars['String']['output']>;
};

export type ImageSubscription = {
  url?: Maybe<Scalars['String']['output']>;
};

export type ImageSubscriptionUpdate = {
  url?: InputMaybe<Scalars['String']['input']>;
};

export type KeyPerformanceIndicators = {
  dishes?: Maybe<Dishes>;
  revenue?: Maybe<ComparisonData>;
  transactions?: Maybe<ComparisonData>;
};

export type LedLight = {
  color?: Maybe<LightColor>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type LedLightSubscription = {
  color?: Maybe<LightColorSubscription>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type LedLightSubscriptionUpdate = {
  color?: InputMaybe<LightColorSubscriptionUpdate>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type LedLightUpdate = {
  color?: InputMaybe<LightColorUpdate>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type LightColor = {
  b?: Maybe<Scalars['Int']['output']>;
  g?: Maybe<Scalars['Int']['output']>;
  r?: Maybe<Scalars['Int']['output']>;
  w?: Maybe<Scalars['Int']['output']>;
};

export type LightColorSubscription = {
  b?: Maybe<Scalars['Int']['output']>;
  g?: Maybe<Scalars['Int']['output']>;
  r?: Maybe<Scalars['Int']['output']>;
  w?: Maybe<Scalars['Int']['output']>;
};

export type LightColorSubscriptionUpdate = {
  b?: InputMaybe<Scalars['Int']['input']>;
  g?: InputMaybe<Scalars['Int']['input']>;
  r?: InputMaybe<Scalars['Int']['input']>;
  w?: InputMaybe<Scalars['Int']['input']>;
};

export type LightColorUpdate = {
  b?: InputMaybe<Scalars['Int']['input']>;
  g?: InputMaybe<Scalars['Int']['input']>;
  r?: InputMaybe<Scalars['Int']['input']>;
  w?: InputMaybe<Scalars['Int']['input']>;
};

export type Lighting = {
  mode?: Maybe<LightingModeType>;
};

export enum LightingModeType {
  Active = 'ACTIVE',
  StandBy = 'STAND_BY'
}

export enum LightingSegmentModeType {
  Default = 'DEFAULT',
  Spotlight = 'SPOTLIGHT'
}

export type LightingSubscription = {
  mode?: Maybe<LightingModeType>;
};

export type LightingSubscriptionUpdate = {
  mode?: InputMaybe<LightingModeType>;
};

export type LightingUpdate = {
  mode?: InputMaybe<LightingModeType>;
};

export enum LocationState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum LockState {
  Locked = 'LOCKED',
  Unlocked = 'UNLOCKED'
}

export type Mutation = {
  addApplePayPaymentMethod: ApplePayResult;
  addGooglePayPaymentMethod: GooglePayResult;
  addPaymentCardPaymentMethod: PaymentCardResult;
  addPluxeeCardPaymentMethod: PluxeeCardAdditionResult;
  adminApproveMcpConsent: AdminMcpConsentDecisionResponse;
  adminCreateAccessCard: AdminAccessCardMutationResponse;
  adminCreateClientUser: AdminClientUserMutationResponse;
  adminCreateCompany: AdminCompanyMutationResponse;
  adminCreateDishType: AdminDishTypeMutationResponse;
  adminCreateFridge: AdminFridgeMutationResponse;
  adminCreateLocation: AdminLocationMutationResponse;
  adminCreateOperator: AdminOperatorMutationResponse;
  adminCreateProfile: AdminProfileMutationResponse;
  adminCreateProfileLinkCode: AdminProfileLinkCodeResponse;
  adminCreateSalesPoint: AdminSalesPointMutationResponse;
  adminDenyMcpConsent: AdminMcpConsentDecisionResponse;
  adminDisconnectProfileAccount: AdminDisconnectProfileAccountResponse;
  adminEditFridgeSalesPointPairing: AdminFridgeSalesPointPairingResponse;
  adminLoginWithCode: UserLogin;
  adminLogout: UserLogout;
  adminPairCompanyLocation: AdminCompanyPairingResponse;
  adminPairFridgeWithSalesPoint: AdminFridgeSalesPointPairingResponse;
  adminRefundTransactionDish: AdminTransactionDishRefund;
  adminRequestLoginCode: AdminLoginCodeRequestResponse;
  adminResetClientUserPassword: AdminClientUserResetPasswordResponse;
  adminRevokeMcpGrant: AdminRevokeMcpGrantResponse;
  adminUnpairCompanyLocation: AdminCompanyPairingResponse;
  adminUnpairFridgeFromSalesPoint: AdminFridgeSalesPointPairingResponse;
  adminUpdateAccessCard: AdminAccessCardMutationResponse;
  adminUpdateClientUser: AdminClientUserMutationResponse;
  adminUpdateCompany: AdminCompanyMutationResponse;
  adminUpdateDishType: AdminDishTypeMutationResponse;
  adminUpdateFridge: AdminFridgeMutationResponse;
  adminUpdateLocation: AdminLocationMutationResponse;
  adminUpdateOperator: AdminOperatorMutationResponse;
  adminUpdateProfile: AdminProfileMutationResponse;
  adminUpdateSalesPoint: AdminSalesPointMutationResponse;
  confirmPluxeeCardPaymentMethod: PluxeeCardConfirmationResult;
  createAccessCard: AccessCard;
  createUserAccountApple: UserAccountSecret;
  createUserAccountGoogle: UserAccountSecret;
  createUserProfile: UserProfile;
  createUserProfileLink: UserProfileLinkResponse;
  createUserProfileLinkCode: UserProfileLinkCodeResponse;
  deletePaymentMethod: DeletePaymentMethodResult;
  loginWithPassword: UserLogin;
  loginWithSecret: UserLogin;
  logout: UserLogout;
  payOrderWithApplePay: ApplePayResult;
  payOrderWithGooglePay: GooglePayResult;
  processThreeDSResult: ThreeDsResultProcessingResult;
  rateDishType: DishTypeRatingResult;
  rateOrder: OrderFeedbackRatingResult;
  rateOrderDish: OrderDishRatingResult;
  registerDeviceToken: DeviceTokenResponse;
  resetPassword: UserResetPassword;
  setPassword: UserSetPassword;
  storeFeedback: FeedbackResult;
  unlockFridge: FridgeUnlockResponse;
  unpairUserAccount: UserAccountUnpair;
  unpairUserAccountApple: UserAccountUnpair;
  unpairUserAccountGoogle: UserAccountUnpair;
  unregisterDeviceToken: DeviceTokenResponse;
  updateAccessCard: AccessCard;
  updateCurrentUser: User;
  updateCurrentUserSubscription: UserSubscription;
  updateFridge: Fridge;
  updateFridgeSubscription: FridgeSubscription;
  updateUserProfile: UserProfile;
};


export type MutationAddApplePayPaymentMethodArgs = {
  input: ApplePayUpdate;
};


export type MutationAddGooglePayPaymentMethodArgs = {
  input: GooglePayUpdate;
};


export type MutationAddPaymentCardPaymentMethodArgs = {
  input: PaymentCardUpdate;
};


export type MutationAddPluxeeCardPaymentMethodArgs = {
  input: PluxeeCardAdditionUpdate;
};


export type MutationAdminApproveMcpConsentArgs = {
  input: AdminMcpConsentApprovalInput;
};


export type MutationAdminCreateAccessCardArgs = {
  input: AdminCreateAccessCardInput;
};


export type MutationAdminCreateClientUserArgs = {
  input: AdminCreateClientUserInput;
};


export type MutationAdminCreateCompanyArgs = {
  input: AdminCreateCompanyInput;
};


export type MutationAdminCreateDishTypeArgs = {
  input: AdminCreateDishTypeInput;
};


export type MutationAdminCreateFridgeArgs = {
  input: AdminCreateFridgeInput;
};


export type MutationAdminCreateLocationArgs = {
  input: AdminCreateLocationInput;
};


export type MutationAdminCreateOperatorArgs = {
  input: AdminCreateOperatorInput;
};


export type MutationAdminCreateProfileArgs = {
  input: AdminCreateProfileInput;
};


export type MutationAdminCreateProfileLinkCodeArgs = {
  input: AdminCreateProfileLinkCodeInput;
};


export type MutationAdminCreateSalesPointArgs = {
  input: AdminCreateSalesPointInput;
};


export type MutationAdminDenyMcpConsentArgs = {
  input: AdminMcpConsentRequestInput;
};


export type MutationAdminDisconnectProfileAccountArgs = {
  input: AdminDisconnectProfileAccountInput;
};


export type MutationAdminEditFridgeSalesPointPairingArgs = {
  input: AdminEditFridgeSalesPointPairingInput;
};


export type MutationAdminLoginWithCodeArgs = {
  input: AdminLoginWithCodeInput;
};


export type MutationAdminPairCompanyLocationArgs = {
  input: AdminCompanyLocationPairInput;
};


export type MutationAdminPairFridgeWithSalesPointArgs = {
  input: AdminPairFridgeWithSalesPointInput;
};


export type MutationAdminRefundTransactionDishArgs = {
  input: AdminRefundTransactionDishInput;
};


export type MutationAdminRequestLoginCodeArgs = {
  input: AdminRequestLoginCodeInput;
};


export type MutationAdminResetClientUserPasswordArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminRevokeMcpGrantArgs = {
  input: AdminRevokeMcpGrantInput;
};


export type MutationAdminUnpairCompanyLocationArgs = {
  input: AdminCompanyLocationPairInput;
};


export type MutationAdminUnpairFridgeFromSalesPointArgs = {
  input: AdminUnpairFridgeFromSalesPointInput;
};


export type MutationAdminUpdateAccessCardArgs = {
  input: AdminUpdateAccessCardInput;
};


export type MutationAdminUpdateClientUserArgs = {
  input: AdminUpdateClientUserInput;
};


export type MutationAdminUpdateCompanyArgs = {
  input: AdminUpdateCompanyInput;
};


export type MutationAdminUpdateDishTypeArgs = {
  input: AdminUpdateDishTypeInput;
};


export type MutationAdminUpdateFridgeArgs = {
  input: AdminUpdateFridgeInput;
};


export type MutationAdminUpdateLocationArgs = {
  input: AdminUpdateLocationInput;
};


export type MutationAdminUpdateOperatorArgs = {
  input: AdminUpdateOperatorInput;
};


export type MutationAdminUpdateProfileArgs = {
  input: AdminUpdateProfileInput;
};


export type MutationAdminUpdateSalesPointArgs = {
  input: AdminUpdateSalesPointInput;
};


export type MutationConfirmPluxeeCardPaymentMethodArgs = {
  input: PluxeeCardConfirmationUpdate;
};


export type MutationCreateAccessCardArgs = {
  input: NewAccessCardInput;
};


export type MutationCreateUserAccountAppleArgs = {
  input: UserAppleLoginInput;
};


export type MutationCreateUserAccountGoogleArgs = {
  input: UserGoogleLoginInput;
};


export type MutationCreateUserProfileArgs = {
  input: NewUserProfileInput;
};


export type MutationCreateUserProfileLinkArgs = {
  input: UserAccountLinkInput;
};


export type MutationCreateUserProfileLinkCodeArgs = {
  input: NewUserProfileLinkCodeInput;
};


export type MutationDeletePaymentMethodArgs = {
  input: Scalars['ID']['input'];
};


export type MutationLoginWithPasswordArgs = {
  input: UserPasswordLoginInput;
};


export type MutationLoginWithSecretArgs = {
  input: UserSecretLoginInput;
};


export type MutationPayOrderWithApplePayArgs = {
  input: ApplePayOrderUpdate;
};


export type MutationPayOrderWithGooglePayArgs = {
  input: GooglePayOrderUpdate;
};


export type MutationProcessThreeDsResultArgs = {
  input: ThreeDsResultProcessingUpdate;
};


export type MutationRateDishTypeArgs = {
  input: DishTypeRatingUpdate;
};


export type MutationRateOrderArgs = {
  input: OrderFeedbackRatingUpdate;
};


export type MutationRateOrderDishArgs = {
  input: OrderDishRatingUpdate;
};


export type MutationRegisterDeviceTokenArgs = {
  input: DeviceTokenInput;
};


export type MutationResetPasswordArgs = {
  input: UserResetPasswordInput;
};


export type MutationSetPasswordArgs = {
  input: UserSetPasswordInput;
};


export type MutationStoreFeedbackArgs = {
  input: FeedbackUpdate;
};


export type MutationUnlockFridgeArgs = {
  input: FridgeUnlock;
};


export type MutationUnregisterDeviceTokenArgs = {
  input: DeviceTokenInput;
};


export type MutationUpdateAccessCardArgs = {
  input: AccessCardInput;
};


export type MutationUpdateCurrentUserArgs = {
  input: UserUpdate;
};


export type MutationUpdateCurrentUserSubscriptionArgs = {
  input: UserSubscriptionUpdate;
};


export type MutationUpdateFridgeArgs = {
  input: FridgeUpdate;
};


export type MutationUpdateFridgeSubscriptionArgs = {
  input: FridgeSubscriptionUpdate;
};


export type MutationUpdateUserProfileArgs = {
  input: UserProfileInput;
};

export type NewAccessCardInput = {
  key: Scalars['String']['input'];
  status: AccessCardStatus;
  type: AccessCardType;
  userId: Scalars['ID']['input'];
  validity: DateTimeRangeInput;
};

export type NewUserProfileInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  externalData?: InputMaybe<Array<UserExternalDataEntryInput>>;
  externalId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  role: UserRole;
  state: UserState;
};

export type NewUserProfileLinkCodeInput = {
  id: Scalars['ID']['input'];
};

export type Order = OrderCommon & Transaction & {
  access?: Maybe<TransactionAccess>;
  discountCode?: Maybe<AppliedDiscountCode>;
  end?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Error>;
  fridge?: Maybe<Fridge>;
  id: Scalars['ID']['output'];
  inventory?: Maybe<TransactionInventory>;
  payment?: Maybe<Payment>;
  price?: Maybe<OrderPrice>;
  result?: Maybe<TransactionResult>;
  start?: Maybe<Scalars['String']['output']>;
  state?: Maybe<TransactionState>;
  summary?: Maybe<OrderSummary>;
  type?: Maybe<TransactionType>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type OrderCommon = {
  end?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  payment?: Maybe<Payment>;
  price?: Maybe<OrderPrice>;
  result?: Maybe<TransactionResult>;
  start?: Maybe<Scalars['String']['output']>;
};

export type OrderDishRatingResult = {
  error?: Maybe<Error>;
};

export type OrderDishRatingUpdate = {
  comment?: InputMaybe<Scalars['String']['input']>;
  dishTypeId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
  rating: Rating;
};

export type OrderFeedbackRating = {
  comment?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<OrderFeedbackReasonType>;
  type?: Maybe<OrderFeedbackRatingType>;
};

export type OrderFeedbackRatingResult = {
  error?: Maybe<Error>;
};

export enum OrderFeedbackRatingType {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE'
}

export type OrderFeedbackRatingUpdate = {
  comment?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
  reason?: InputMaybe<OrderFeedbackReasonType>;
  type: OrderFeedbackRatingType;
};

export enum OrderFeedbackReasonType {
  EmployeeAccountIssue = 'EMPLOYEE_ACCOUNT_ISSUE',
  JustLooking = 'JUST_LOOKING',
  MenuIssue = 'MENU_ISSUE',
  NothingInteresting = 'NOTHING_INTERESTING',
  NotCharged = 'NOT_CHARGED',
  Other = 'OTHER',
  Overcharged = 'OVERCHARGED',
  PaymentIssue = 'PAYMENT_ISSUE',
  SomethingWentWrong = 'SOMETHING_WENT_WRONG'
}

export type OrderPaymentMethodUpdate = {
  id: Scalars['ID']['input'];
};

export type OrderPaymentUpdate = {
  method?: InputMaybe<OrderPaymentMethodUpdate>;
};

export type OrderPrice = {
  total?: Maybe<Price>;
};

export type OrderPriceSubscription = {
  total?: Maybe<PriceSubscription>;
};

export type OrderPriceSubscriptionUpdate = {
  total?: InputMaybe<PriceSubscriptionUpdate>;
};

export type OrderSubscription = {
  access?: Maybe<TransactionAccessSubscription>;
  discountCode?: Maybe<AppliedDiscountCodeSubscription>;
  end?: Maybe<Scalars['String']['output']>;
  fridge?: Maybe<FridgeSubscription>;
  id: Scalars['ID']['output'];
  inventory?: Maybe<TransactionInventorySubscription>;
  payment?: Maybe<PaymentSubscription>;
  price?: Maybe<OrderPriceSubscription>;
  result?: Maybe<TransactionResult>;
  start?: Maybe<Scalars['String']['output']>;
  state?: Maybe<TransactionState>;
  summary?: Maybe<OrderSummarySubscription>;
  type?: Maybe<TransactionType>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserSubscription>;
};

export type OrderSubscriptionUpdate = {
  access?: InputMaybe<TransactionAccessSubscriptionUpdate>;
  discountCode?: InputMaybe<AppliedDiscountCodeSubscriptionUpdate>;
  end?: InputMaybe<Scalars['String']['input']>;
  fridge?: InputMaybe<FridgeSubscriptionUpdate>;
  id: Scalars['ID']['input'];
  inventory?: InputMaybe<TransactionInventorySubscriptionUpdate>;
  payment?: InputMaybe<PaymentSubscriptionUpdate>;
  price?: InputMaybe<OrderPriceSubscriptionUpdate>;
  result?: InputMaybe<TransactionResult>;
  start?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<TransactionState>;
  summary?: InputMaybe<OrderSummarySubscriptionUpdate>;
  type?: InputMaybe<TransactionType>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserSubscriptionUpdate>;
};

export type OrderSummary = {
  items?: Maybe<Array<OrderSummaryItem>>;
};

export type OrderSummaryCompensationItem = {
  dishType?: Maybe<DishType>;
  price?: Maybe<Price>;
};

export type OrderSummaryDiscountItem = {
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Price>;
};

export type OrderSummaryDishItem = {
  count?: Maybe<Scalars['Int']['output']>;
  dishType?: Maybe<DishType>;
  price?: Maybe<OrderSummaryItemPrice>;
};

export type OrderSummaryItem = OrderSummaryCompensationItem | OrderSummaryDiscountItem | OrderSummaryDishItem;

export type OrderSummaryItemDetailDescriptionSubscription = {
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type OrderSummaryItemDetailDescriptionSubscriptionUpdate = {
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type OrderSummaryItemDetailSubscription = {
  primary?: Maybe<OrderSummaryItemDetailDescriptionSubscription>;
  secondary?: Maybe<OrderSummaryItemDetailDescriptionSubscription>;
};

export type OrderSummaryItemDetailSubscriptionUpdate = {
  primary?: InputMaybe<OrderSummaryItemDetailDescriptionSubscriptionUpdate>;
  secondary?: InputMaybe<OrderSummaryItemDetailDescriptionSubscriptionUpdate>;
};

export type OrderSummaryItemPrice = {
  item?: Maybe<Price>;
  total?: Maybe<Price>;
};

export type OrderSummaryItemPriceSubscription = {
  item?: Maybe<PriceSubscription>;
  total?: Maybe<PriceSubscription>;
};

export type OrderSummaryItemPriceSubscriptionUpdate = {
  item?: InputMaybe<PriceSubscriptionUpdate>;
  total?: InputMaybe<PriceSubscriptionUpdate>;
};

export type OrderSummaryItemSubscription = {
  count?: Maybe<Scalars['Int']['output']>;
  detail?: Maybe<OrderSummaryItemDetailSubscription>;
  dishType?: Maybe<DishTypeSubscription>;
  price?: Maybe<OrderSummaryItemPriceSubscription>;
};

export type OrderSummaryItemSubscriptionUpdate = {
  count?: InputMaybe<Scalars['Int']['input']>;
  detail?: InputMaybe<OrderSummaryItemDetailSubscriptionUpdate>;
  dishType?: InputMaybe<DishTypeSubscriptionUpdate>;
  price?: InputMaybe<OrderSummaryItemPriceSubscriptionUpdate>;
};

export type OrderSummarySubscription = {
  items?: Maybe<Array<OrderSummaryItemSubscription>>;
};

export type OrderSummarySubscriptionUpdate = {
  items?: InputMaybe<Array<OrderSummaryItemSubscriptionUpdate>>;
};

export type OrderUpdate = {
  id: Scalars['ID']['input'];
  payment?: InputMaybe<OrderPaymentUpdate>;
};

export type OrderWithFridge = OrderCommon & {
  end?: Maybe<Scalars['String']['output']>;
  feedback?: Maybe<OrderFeedbackRating>;
  fridge?: Maybe<FridgeBase>;
  id: Scalars['ID']['output'];
  inventory?: Maybe<TransactionInventoryBase>;
  payment?: Maybe<Payment>;
  price?: Maybe<OrderPrice>;
  result?: Maybe<TransactionResult>;
  start?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type Orders = {
  all?: Maybe<AllOrders>;
  current?: Maybe<Order>;
  last?: Maybe<Order>;
};


export type OrdersAllArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
};

export type OrdersSubscription = {
  current?: Maybe<OrderSubscription>;
  last?: Maybe<OrderSubscription>;
};

export type OrdersSubscriptionUpdate = {
  current?: InputMaybe<OrderSubscriptionUpdate>;
  last?: InputMaybe<OrderSubscriptionUpdate>;
};

export type OrdersUpdate = {
  last: OrderUpdate;
};

export type PaginationInput = {
  items?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type Payment = {
  error?: Maybe<Error>;
  method?: Maybe<PaymentMethod>;
  state?: Maybe<PaymentState>;
};

export type PaymentBrowserUpdate = {
  accept?: InputMaybe<Scalars['String']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentCardDataExpirationUpdate = {
  month: Scalars['String']['input'];
  year: Scalars['String']['input'];
};

export type PaymentCardDataUpdate = {
  cvc: Scalars['String']['input'];
  expiration: PaymentCardDataExpirationUpdate;
  number: Scalars['String']['input'];
};

export type PaymentCardResult = {
  error?: Maybe<Error>;
  method?: Maybe<PaymentMethod>;
  redirect?: Maybe<PaymentRedirect>;
};

export type PaymentCardUpdate = {
  data: PaymentCardDataUpdate;
  name: Scalars['String']['input'];
};

export type PaymentFilterInput = {
  method?: InputMaybe<PaymentMethodFilterInput>;
  state?: InputMaybe<PaymentState>;
};

export type PaymentMethod = {
  error?: Maybe<Error>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<PaymentMethodState>;
  type?: Maybe<PaymentMethodType>;
};

export type PaymentMethodFilterInput = {
  type?: InputMaybe<PaymentMethodType>;
};

export enum PaymentMethodState {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Pending = 'PENDING'
}

export type PaymentMethodSubscription = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<PaymentMethodState>;
  type?: Maybe<PaymentMethodType>;
};

export type PaymentMethodSubscriptionUpdate = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<PaymentMethodState>;
  type?: InputMaybe<PaymentMethodType>;
};

export enum PaymentMethodType {
  EmployeeCard = 'EMPLOYEE_CARD',
  NativePay = 'NATIVE_PAY',
  NativePayTopUp = 'NATIVE_PAY_TOP_UP',
  PaymentCardTopUp = 'PAYMENT_CARD_TOP_UP',
  PluxeeCardTopUp = 'PLUXEE_CARD_TOP_UP'
}

export type PaymentMethodUpdate = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<PaymentMethodState>;
};

export type PaymentRedirect = AdyenPaymentRedirect;

export enum PaymentState {
  Failed = 'FAILED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type PaymentSubscription = {
  method?: Maybe<PaymentMethodSubscription>;
  state?: Maybe<PaymentState>;
};

export type PaymentSubscriptionUpdate = {
  method?: InputMaybe<PaymentMethodSubscriptionUpdate>;
  state?: InputMaybe<PaymentState>;
};

export type PaymentUpdate = {
  method?: InputMaybe<PaymentMethodUpdate>;
};

export type PluxeeCardAdditionError = {
  message?: Maybe<Scalars['String']['output']>;
  type: PluxeeCardAdditionErrorType;
};

export enum PluxeeCardAdditionErrorType {
  InvalidCard = 'INVALID_CARD',
  PhoneNumberNotSet = 'PHONE_NUMBER_NOT_SET'
}

export type PluxeeCardAdditionResult = {
  error?: Maybe<PluxeeCardAdditionResultError>;
  method?: Maybe<PaymentMethod>;
};

export type PluxeeCardAdditionResultError = Error | PluxeeCardAdditionError;

export type PluxeeCardAdditionUpdate = {
  data: PluxeeCardDataUpdate;
  name: Scalars['String']['input'];
};

export type PluxeeCardConfirmationError = {
  message?: Maybe<Scalars['String']['output']>;
  type: PluxeeCardConfirmationErrorType;
};

export enum PluxeeCardConfirmationErrorType {
  InvalidCode = 'INVALID_CODE',
  RegistrationMissing = 'REGISTRATION_MISSING',
  Timeout = 'TIMEOUT'
}

export type PluxeeCardConfirmationResult = {
  error?: Maybe<PluxeeCardConfirmationResultError>;
  method?: Maybe<PaymentMethod>;
};

export type PluxeeCardConfirmationResultError = Error | PluxeeCardConfirmationError;

export type PluxeeCardConfirmationUpdate = {
  code: Scalars['String']['input'];
  data: PluxeeCardDataUpdate;
  id: Scalars['ID']['input'];
};

export type PluxeeCardDataUpdate = {
  number: Scalars['String']['input'];
};

export type Price = {
  currency?: Maybe<CurrencyType>;
  current?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['String']['output']>;
};

export type PriceSubscription = {
  currency?: Maybe<CurrencyType>;
  current?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['String']['output']>;
};

export type PriceSubscriptionUpdate = {
  currency?: InputMaybe<CurrencyType>;
  current?: InputMaybe<Scalars['String']['input']>;
  default?: InputMaybe<Scalars['String']['input']>;
};

export type PriceUpdate = {
  currency?: InputMaybe<CurrencyType>;
  current?: InputMaybe<Scalars['String']['input']>;
  default?: InputMaybe<Scalars['String']['input']>;
};

export type Profile = {
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type QrCode = {
  code?: Maybe<Scalars['String']['output']>;
};

export type QrCodeSubscription = {
  code?: Maybe<Scalars['String']['output']>;
};

export type QrCodeSubscriptionUpdate = {
  code?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  accessCard: AccessCard;
  accessCards: AccessCardsResponse;
  adminAccessCard?: Maybe<AdminAccessCardResponse>;
  adminAccessCards?: Maybe<AdminAccessCardsResponse>;
  adminClientUser?: Maybe<AdminClientUserResponse>;
  adminClientUsers?: Maybe<AdminClientUsersResponse>;
  adminCompanies?: Maybe<AdminCompaniesResponse>;
  adminCompanyList?: Maybe<AdminCompanyListResponse>;
  adminCurrentUser: User;
  adminDishType: AdminDishTypeResponse;
  adminDishTypes: AdminDishTypesResponse;
  adminFridge?: Maybe<AdminFridgeResponse>;
  adminFridgeOptions?: Maybe<AdminFridgeOptionsResponse>;
  adminFridgeTemperatures?: Maybe<AdminFridgeTemperaturesResponse>;
  adminFridgeTypes?: Maybe<AdminFridgeTypesResponse>;
  adminFridges?: Maybe<AdminFridgesListResponse>;
  adminLocationList?: Maybe<AdminLocationListResponse>;
  adminLocations?: Maybe<AdminLocationsResponse>;
  adminMcpConsentRequest?: Maybe<AdminMcpConsentRequestResponse>;
  adminMcpGrants?: Maybe<AdminMcpGrantsResponse>;
  adminOperator?: Maybe<AdminOperatorResponse>;
  adminOperators?: Maybe<AdminOperatorsResponse>;
  adminProfile?: Maybe<AdminProfileDetailResponse>;
  adminProfiles?: Maybe<AdminProfilesResponse>;
  adminSalesPoint?: Maybe<AdminSalesPointResponse>;
  adminSalesPointOptions?: Maybe<AdminSalesPointOptionsResponse>;
  adminSalesPoints?: Maybe<AdminSalesPointsResponse>;
  adminTransaction?: Maybe<AdminTransactionResponse>;
  adminTransactionPayments?: Maybe<AdminTransactionPaymentOptions>;
  adminTransactionRecordingUrl?: Maybe<AdminTransactionRecordingResponse>;
  adminTransactions?: Maybe<TransactionsResponse>;
  adminUserAccount?: Maybe<AdminUserAccountDetailResponse>;
  adminUserAccounts?: Maybe<AdminUserAccountsResponse>;
  adminUsers?: Maybe<AdminUsersResponse>;
  clientFridge: Fridge;
  clientFridges: FridgesResponse;
  company: Company;
  currentUser: User;
  fridge: Fridge;
  statistics: SalesStatistics;
  transaction?: Maybe<TransactionResponse>;
  transactions?: Maybe<TransactionsResponse>;
  userProfile: UserProfile;
  userProfiles: UserProfilesResponse;
};


export type QueryAccessCardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccessCardsArgs = {
  filter?: InputMaybe<AccessCardFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
};


export type QueryAdminAccessCardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminAccessCardsArgs = {
  filter?: InputMaybe<AdminAccessCardFilterInput>;
  pagination?: InputMaybe<AdminPaginationInput>;
};


export type QueryAdminClientUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminClientUsersArgs = {
  filter?: InputMaybe<AdminClientUserFilterInput>;
  pagination?: InputMaybe<AdminPaginationInput>;
};


export type QueryAdminDishTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminDishTypesArgs = {
  filter?: InputMaybe<AdminDishTypesFilterInput>;
  pagination?: InputMaybe<AdminPaginationInput>;
};


export type QueryAdminFridgeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminFridgeTemperaturesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminFridgesArgs = {
  filter?: InputMaybe<AdminFridgeFilterInput>;
  pagination?: InputMaybe<AdminPaginationInput>;
};


export type QueryAdminMcpConsentRequestArgs = {
  input: AdminMcpConsentRequestInput;
};


export type QueryAdminOperatorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminOperatorsArgs = {
  filter?: InputMaybe<AdminOperatorFilterInput>;
  pagination?: InputMaybe<AdminPaginationInput>;
};


export type QueryAdminProfileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminProfilesArgs = {
  filter?: InputMaybe<AdminProfileFilterInput>;
  pagination?: InputMaybe<AdminPaginationInput>;
};


export type QueryAdminSalesPointArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminSalesPointsArgs = {
  filter?: InputMaybe<AdminSalesPointsFilterInput>;
  pagination?: InputMaybe<AdminPaginationInput>;
};


export type QueryAdminTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminTransactionRecordingUrlArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminTransactionsArgs = {
  filter?: InputMaybe<AdminTransactionFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
};


export type QueryAdminUserAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminUserAccountsArgs = {
  filter?: InputMaybe<AdminUserAccountFilterInput>;
  pagination?: InputMaybe<AdminPaginationInput>;
};


export type QueryAdminUsersArgs = {
  roles?: InputMaybe<Array<UserRole>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClientFridgeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientFridgesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
};


export type QueryFridgeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTransactionsArgs = {
  filter?: InputMaybe<TransactionFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
};


export type QueryUserProfileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserProfilesArgs = {
  filter?: InputMaybe<UserFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
};

export type QueryInput = {
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum Rating {
  Five = 'FIVE',
  Four = 'FOUR',
  One = 'ONE',
  Three = 'THREE',
  Two = 'TWO'
}

export type RecentFridges = {
  edges?: Maybe<Array<FridgeBase>>;
  pageInfo?: Maybe<RecentFridgesPageInfo>;
};

export type RecentFridgesPageInfo = {
  endCursor?: Maybe<Scalars['ID']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
};

export type Refill = RefillCommon & Transaction & {
  access?: Maybe<TransactionAccess>;
  end?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Error>;
  fridge?: Maybe<Fridge>;
  id: Scalars['ID']['output'];
  inventory?: Maybe<TransactionInventory>;
  mode?: Maybe<RefillTransactionMode>;
  result?: Maybe<TransactionResult>;
  start?: Maybe<Scalars['String']['output']>;
  state?: Maybe<TransactionState>;
  type?: Maybe<TransactionType>;
  user?: Maybe<User>;
};

export type RefillCommon = {
  end?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  result?: Maybe<TransactionResult>;
  start?: Maybe<Scalars['String']['output']>;
};

export type RefillSubscription = {
  access?: Maybe<TransactionAccessSubscription>;
  end?: Maybe<Scalars['String']['output']>;
  fridge?: Maybe<FridgeSubscription>;
  id: Scalars['ID']['output'];
  inventory?: Maybe<TransactionInventorySubscription>;
  mode?: Maybe<RefillTransactionMode>;
  result?: Maybe<TransactionResult>;
  start?: Maybe<Scalars['String']['output']>;
  state?: Maybe<TransactionState>;
  type?: Maybe<TransactionType>;
  user?: Maybe<UserSubscription>;
};

export type RefillSubscriptionUpdate = {
  access?: InputMaybe<TransactionAccessSubscriptionUpdate>;
  end?: InputMaybe<Scalars['String']['input']>;
  fridge?: InputMaybe<FridgeSubscriptionUpdate>;
  id: Scalars['ID']['input'];
  inventory?: InputMaybe<TransactionInventorySubscriptionUpdate>;
  mode?: InputMaybe<RefillTransactionMode>;
  result?: InputMaybe<TransactionResult>;
  start?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<TransactionState>;
  type?: InputMaybe<TransactionType>;
  user?: InputMaybe<UserSubscriptionUpdate>;
};

export enum RefillTransactionMode {
  Remote = 'REMOTE'
}

export type RefillWithFridge = RefillCommon & {
  end?: Maybe<Scalars['String']['output']>;
  fridge?: Maybe<FridgeBase>;
  id: Scalars['ID']['output'];
  inventory?: Maybe<TransactionInventoryBase>;
  result?: Maybe<TransactionResult>;
  start?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type Refills = {
  all?: Maybe<Array<Refill>>;
  last?: Maybe<Refill>;
};

export type RefillsSubscription = {
  last?: Maybe<RefillSubscription>;
};

export type RefillsSubscriptionUpdate = {
  last?: InputMaybe<RefillSubscriptionUpdate>;
};

export type SalesStatistics = {
  bestsellers?: Maybe<Bestsellers>;
  error?: Maybe<Error>;
  keyPerformanceIndicators?: Maybe<KeyPerformanceIndicators>;
  orders?: Maybe<Array<AggregatedData>>;
};


export type SalesStatisticsBestsellersArgs = {
  fridgeId: Scalars['ID']['input'];
  range: DateRange;
};


export type SalesStatisticsKeyPerformanceIndicatorsArgs = {
  fridgeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  range: DateRange;
};


export type SalesStatisticsOrdersArgs = {
  fridgeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupBy: DataGroup;
  range: DateRange;
};

export type SegmentLedLights = {
  all?: Maybe<LightColor>;
  leds?: Maybe<Array<LedLight>>;
};

export type SegmentLedLightsSubscription = {
  all?: Maybe<LightColorSubscription>;
  leds?: Maybe<Array<LedLightSubscription>>;
};

export type SegmentLedLightsSubscriptionUpdate = {
  all?: InputMaybe<LightColorSubscriptionUpdate>;
  leds?: InputMaybe<Array<LedLightSubscriptionUpdate>>;
};

export type SegmentLedLightsUpdate = {
  all?: InputMaybe<LightColorUpdate>;
  leds?: InputMaybe<Array<LedLightUpdate>>;
};

export type SegmentLight = {
  ambient?: Maybe<SegmentLedLights>;
  front?: Maybe<SegmentLedLights>;
};

export type SegmentLightSubscription = {
  ambient?: Maybe<SegmentLedLightsSubscription>;
  front?: Maybe<SegmentLedLightsSubscription>;
};

export type SegmentLightSubscriptionUpdate = {
  ambient?: InputMaybe<SegmentLedLightsSubscriptionUpdate>;
  front?: InputMaybe<SegmentLedLightsSubscriptionUpdate>;
};

export type SegmentLightUpdate = {
  ambient?: InputMaybe<SegmentLedLightsUpdate>;
  front?: InputMaybe<SegmentLedLightsUpdate>;
};

export type SortInput = {
  fields?: InputMaybe<Array<SortValueInput>>;
};

export enum SortType {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export type SortValueInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<SortType>;
};

export type Subscription = {
  currentUser?: Maybe<UserSubscription>;
  fridge?: Maybe<FridgeSubscription>;
};


export type SubscriptionCurrentUserArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionFridgeArgs = {
  id: Scalars['ID']['input'];
};

export type ThreeDsResultProcessingResult = {
  error?: Maybe<Error>;
  method?: Maybe<PaymentMethod>;
};

export type ThreeDsResultProcessingUpdate = {
  data?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type Transaction = {
  access?: Maybe<TransactionAccess>;
  end?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Error>;
  fridge?: Maybe<Fridge>;
  id: Scalars['ID']['output'];
  inventory?: Maybe<TransactionInventory>;
  result?: Maybe<TransactionResult>;
  start?: Maybe<Scalars['String']['output']>;
  state?: Maybe<TransactionState>;
  type?: Maybe<TransactionType>;
  user?: Maybe<User>;
};

export type TransactionAccess = {
  type?: Maybe<TransactionAccessType>;
};

export type TransactionAccessSubscription = {
  type?: Maybe<TransactionAccessType>;
};

export type TransactionAccessSubscriptionUpdate = {
  type?: InputMaybe<TransactionAccessType>;
};

export enum TransactionAccessType {
  Card = 'CARD',
  QrCode = 'QR_CODE'
}

export type TransactionFilterInput = {
  fridgeId?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  payment?: InputMaybe<PaymentFilterInput>;
  query?: InputMaybe<QueryInput>;
  range?: InputMaybe<DateTimeRangeInput>;
  type?: InputMaybe<TransactionType>;
};

export type TransactionInventory = {
  added?: Maybe<Array<Dish>>;
  removed?: Maybe<Array<Dish>>;
  updated?: Maybe<Array<Dish>>;
};

export type TransactionInventoryBase = {
  added?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<TransactionInventoryPrice>;
  removed?: Maybe<Scalars['Int']['output']>;
};

export type TransactionInventoryPrice = {
  added?: Maybe<Scalars['String']['output']>;
  removed?: Maybe<Scalars['String']['output']>;
};

export type TransactionInventorySubscription = {
  added?: Maybe<Array<DishSubscription>>;
  removed?: Maybe<Array<DishSubscription>>;
  updated?: Maybe<Array<DishSubscription>>;
};

export type TransactionInventorySubscriptionUpdate = {
  added?: InputMaybe<Array<DishSubscriptionUpdate>>;
  removed?: InputMaybe<Array<DishSubscriptionUpdate>>;
  updated?: InputMaybe<Array<DishSubscriptionUpdate>>;
};

export type TransactionResponse = Order | Refill;

export enum TransactionResult {
  Error = 'ERROR',
  Success = 'SUCCESS',
  Timeout = 'TIMEOUT',
  Unauthorized = 'UNAUTHORIZED'
}

export enum TransactionState {
  Active = 'ACTIVE',
  Finished = 'FINISHED',
  StockCheck = 'STOCK_CHECK'
}

export type TransactionSummary = OrderWithFridge | RefillWithFridge;

export enum TransactionType {
  Order = 'ORDER',
  Refill = 'REFILL'
}

export type TransactionsResponse = {
  error?: Maybe<Error>;
  items?: Maybe<Array<TransactionSummary>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type User = Profile & {
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use email instead. */
  emails?: Maybe<Array<Scalars['String']['output']>>;
  error?: Maybe<Error>;
  fridges?: Maybe<UserFridges>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use transaction.orders.all instead. */
  orders?: Maybe<Array<Order>>;
  payment?: Maybe<UserPayment>;
  phone?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use phone instead. */
  phones?: Maybe<Array<Scalars['String']['output']>>;
  preferences?: Maybe<UserPreferences>;
  profiles?: Maybe<Array<UserProfile>>;
  role?: Maybe<UserRole>;
  transaction?: Maybe<FridgeTransaction>;
};

export type UserAccountLinkInput = {
  code: Scalars['String']['input'];
};

export type UserAccountSecret = {
  error?: Maybe<Error>;
  id?: Maybe<Scalars['String']['output']>;
  secret?: Maybe<Scalars['String']['output']>;
};

export type UserAccountUnpair = {
  error?: Maybe<Error>;
};

export type UserAppleLoginInput = {
  authorizationCode: Scalars['String']['input'];
  idToken: Scalars['String']['input'];
  user?: InputMaybe<AppleUser>;
};

export type UserExternalDataEntry = {
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type UserExternalDataEntryInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type UserFilterInput = {
  query?: InputMaybe<QueryInput>;
  role?: InputMaybe<UserRole>;
  state?: InputMaybe<UserState>;
};

export type UserFridges = {
  recent?: Maybe<RecentFridges>;
};


export type UserFridgesRecentArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type UserGoogleLoginInput = {
  idToken: Scalars['String']['input'];
};

export type UserLogin = {
  error?: Maybe<Error>;
  session?: Maybe<Scalars['String']['output']>;
  validTo?: Maybe<Scalars['String']['output']>;
};

export type UserLogout = {
  error?: Maybe<Error>;
};

export type UserPasswordLoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type UserPayment = {
  default?: Maybe<PaymentMethod>;
  error?: Maybe<Error>;
  options?: Maybe<Array<PaymentMethod>>;
};

export type UserPaymentSubscription = {
  default?: Maybe<PaymentMethodSubscription>;
  options?: Maybe<Array<PaymentMethodSubscription>>;
};

export type UserPaymentSubscriptionUpdate = {
  default?: InputMaybe<PaymentMethodSubscriptionUpdate>;
  options?: InputMaybe<Array<PaymentMethodSubscriptionUpdate>>;
};

export type UserPaymentUpdate = {
  default?: InputMaybe<PaymentMethodUpdate>;
  options?: InputMaybe<Array<PaymentMethodUpdate>>;
};

export type UserPreferences = {
  allergens?: Maybe<Array<AllergenType>>;
  language?: Maybe<Scalars['String']['output']>;
};

export type UserPreferencesSubscription = {
  allergens?: Maybe<Array<AllergenType>>;
  language?: Maybe<Scalars['String']['output']>;
};

export type UserPreferencesSubscriptionUpdate = {
  allergens?: InputMaybe<Array<AllergenType>>;
  language?: InputMaybe<Scalars['String']['input']>;
};

export type UserPreferencesUpdate = {
  allergens?: InputMaybe<Array<AllergenType>>;
  language?: InputMaybe<Scalars['String']['input']>;
};

export type UserProfile = Profile & {
  accessCards?: Maybe<Array<AccessCard>>;
  email?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Error>;
  externalData?: Maybe<Array<UserExternalDataEntry>>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UserRole>;
  state?: Maybe<UserState>;
  transaction?: Maybe<FridgeTransaction>;
};

export type UserProfileFilterInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UserProfileInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  externalData?: InputMaybe<Array<UserExternalDataEntryInput>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  state?: InputMaybe<UserState>;
};

export type UserProfileLinkCodeResponse = {
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Error>;
};

export type UserProfileLinkResponse = {
  error?: Maybe<Error>;
};

export type UserProfilesResponse = {
  error?: Maybe<Error>;
  items?: Maybe<Array<UserProfile>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UserResetPassword = {
  error?: Maybe<Error>;
};

export type UserResetPasswordInput = {
  email: Scalars['String']['input'];
};

export enum UserRole {
  Admin = 'ADMIN',
  Ambassador = 'AMBASSADOR',
  Client = 'CLIENT',
  Contractor = 'CONTRACTOR',
  Employee = 'EMPLOYEE',
  External = 'EXTERNAL',
  Logistic = 'LOGISTIC',
  Operator = 'OPERATOR',
  Personal = 'PERSONAL',
  Sales = 'SALES',
  Support = 'SUPPORT',
  Vip = 'VIP',
  Visitor = 'VISITOR'
}

export type UserSecretLoginInput = {
  id: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};

export type UserSetPassword = {
  error?: Maybe<Error>;
};

export type UserSetPasswordInput = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export enum UserState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type UserSubscription = {
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use transaction.orders.last instead. */
  orders?: Maybe<Array<OrderSubscription>>;
  payment?: Maybe<UserPaymentSubscription>;
  preferences?: Maybe<UserPreferencesSubscription>;
  transaction?: Maybe<FridgeTransactionSubscription>;
};

export type UserSubscriptionUpdate = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orders?: InputMaybe<Array<OrderSubscriptionUpdate>>;
  payment?: InputMaybe<UserPaymentSubscriptionUpdate>;
  preferences?: InputMaybe<UserPreferencesSubscriptionUpdate>;
  transaction?: InputMaybe<FridgeTransactionSubscriptionUpdate>;
};

export type UserUpdate = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<UserPaymentUpdate>;
  preferences?: InputMaybe<UserPreferencesUpdate>;
  transaction?: InputMaybe<FridgeTransactionUpdate>;
};
